(function($) {
    var sampleButton1 = $('#ContentPlaceHolder1_ucSampleStep_Button1');
    var sampleButton2 = $('#ContentPlaceHolder1_ucSampleStep_Button2');
    var $autoSelectorElements = $('.js-trigger-selection-hook');
    $autoSelectorElements.each(function() {
        $(this).click(function(event) {
            if ($(event.target).closest('.js-ignore-selection-hook').length === 0) {
                var $productInputCtrl = $(this).find('input[name="products"]');
                if ($productInputCtrl.length > 0) {
                    $('input[id$=hdnSampleId]').val($productInputCtrl.val());
                }
                var $sizeSelect = $(this).find('select#AvailableSizesOfSelectedItem');
                if ($sizeSelect.length > 0) {
                    $('input[id$=hdnSelectedSizeValue]').val($sizeSelect.val());
                } else {
                    $('input[id$=hdnSelectedSizeValue]').val(' ');
                }
                if (typeof SampleSizeValidation === 'function') {
                    SampleSizeValidation();
                }
                if (sampleButton1.length) {
                    sampleButton1.click();
                } else if (sampleButton2.length) {
                    sampleButton2.click();
                }
            }
        });
    });
})(jQuery);
